import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { REVENUE_BY_COUNTRY_QUERY_KEY } from "./constants";
import type { RevenueByCountryResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/financial/
 * revenue-by-country?from=&to=` (API-FIN-6), read tier ADMIN + FINANCE.
 * Disabled until both ends of the range are set. Rows carry their own currency.
 */
export function useRevenueByCountry(from: string, to: string) {
  return useQuery({
    queryKey: [...REVENUE_BY_COUNTRY_QUERY_KEY, from, to] as const,
    queryFn: () =>
      httpClient<RevenueByCountryResponse>(
        `/api/admin/financial/revenue-by-country?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
      ),
    enabled: from.length > 0 && to.length > 0,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}
